import {
  Box,
  Button,
  CircularProgress,
  Paper,
  Typography,
} from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";
import React, { useEffect, useState } from "react";
import { EnquiryTable } from "../../components/dashboard/EnquiryTable";
import { useQuery } from "@tanstack/react-query";
import { manageEnquiryQueryOptions } from "../../queryOptions/ManageBookingsOptions";

interface Enquiry {
  _id: string;
  name: string;
  phoneNumber: Number;
  email: string;
  message: string;
  subject: string;
  createdAt: Date;
}

const Enquirys = () => {
  const [enquiries, setEnquiries] = useState<Enquiry[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [filteredEnquiries, setFilteredEnquiries] = useState<Enquiry[]>([]);
  const [refreshing, setRefreshing] = useState<boolean>(false);
  const [searchTerm] = useState<string>("");
  const { data, refetch } = useQuery(manageEnquiryQueryOptions())

  useEffect(() => {
    if (data) {
      setEnquiries(data);
      setFilteredEnquiries(data);
      setLoading(false);
    }
  }, [data])

  const handleRefresh = async () => {
    setRefreshing(true);
    setLoading(true)
    try {
      await refetch();
      setRefreshing(false);
      setLoading(false);
    } finally {
      setTimeout(() => setRefreshing(false), 500);
    }
  };

  useEffect(() => {
    if (searchTerm) {
      const filtered = enquiries.filter((enquiry) => {
        return (
          enquiry.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
          enquiry.phoneNumber.toString().includes(searchTerm) ||
          enquiry.email.toLowerCase().includes(searchTerm.toLowerCase()) ||
          enquiry.message.toLowerCase().includes(searchTerm.toLowerCase()) ||
          enquiry.subject.toLowerCase().includes(searchTerm)
        );
      });
      setFilteredEnquiries(filtered);
    } else {
      setFilteredEnquiries(enquiries);
    }
  }, [searchTerm, enquiries]);

  return (
    <Box sx={{ px: 2, py: 3 }}>
      <Paper
        elevation={2}
        sx={{
          p: 3,
          borderRadius: 2,
          backgroundColor: "background.paper",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            alignItems: { xs: "stretch", md: "center" },
            justifyContent: "space-between",
            mb: 3,
            gap: 2,
          }}
        >
          <Typography variant="h5" component="h1" fontWeight="bold">
            Manage Enquiry
          </Typography>

          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", sm: "row" },
              gap: 2,
              width: { xs: "100%", md: "auto" },
            }}
          >
            <Button
              variant="outlined"
              color="primary"
              startIcon={
                refreshing ? (
                  <CircularProgress size={20} color="inherit" />
                ) : (
                  <RefreshIcon />
                )
              }
              onClick={handleRefresh}
              disabled={refreshing}
            >
              Refresh
            </Button>
            {/* </Box> */}
          </Box>
        </Box>
        <EnquiryTable
          data={filteredEnquiries}
          loading={loading}
          onStatusChange={console.log}
        />
      </Paper>
    </Box>
  );
};

export default Enquirys;
